export interface Practice {
    place_id: string;
    name: string;
    formatted_address?: string;
    formatted_phone_number?: string;
    website?: string;
}
export function textSearchRequest(input: string) {
    const query = input.trim();
    return { query: `veterinarian ${query}`, type: "veterinary_care" };
}
export function searchPractices(service: any, input: string): Promise<Practice[]> {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error("Search timed out. Please try again.")), 15000);
        try {
            service.textSearch(textSearchRequest(input), (results: Practice[] | null, status: string) => {
                clearTimeout(timer);
                if (status === "ZERO_RESULTS") return resolve([]);
                if (status !== "OK") return reject(new Error("Unable to search practices right now. Please try again."));
                resolve((results || []).filter(p => p.place_id && p.name));
            });
        } catch { clearTimeout(timer); reject(new Error("Unable to search practices right now. Please try again.")); }
    });
}
export function practiceDetails(service: any, practice: Practice): Promise<Practice> {
    return new Promise(resolve => {
        const timer = setTimeout(() => resolve(practice), 10000);
        try {
            service.getDetails({ placeId: practice.place_id, fields: ["place_id", "name", "formatted_address", "formatted_phone_number", "website"] },
                (detail: Practice | null, status: string) => { clearTimeout(timer); resolve(status === "OK" && detail ? detail : practice); });
        } catch { clearTimeout(timer); resolve(practice); }
    });
}
